import { makeStyles } from '@material-ui/core/styles';
import { isDark, grey } from 'global/styles';

const useStyles = makeStyles((theme) => ({
  sidebarWidth: {
    width: '300px',
    height: 'calc(100vh - 64px)',
    [theme.breakpoints.down('md')]: {
      width: '0px',
    },
  },
  fullWidth: {
    width: '100%',
    height: (p) => (p.isMobile ? undefined : 'calc(100vh - 64px)'),
  },
  list: {
    overflowY: 'scroll',
    position: 'fixed',
    zIndex: 100,
    transition: (p) => (p.isMobile ? undefined : theme.transitions.create('width', { duration: theme.transitions.duration.complex })),
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  active: {
    backgroundColor: theme.palette.action.hover,
  },
  noPad: {
    padding: 0,
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: (p) => (p.hasSelected ? 'transparent' : grey(theme, 500)),
  },
  rowIcon: {
    color: theme.palette.grey[500],
    marginLeft: theme.spacing(1),
  },
  rowIconActive: {
    color: isDark(theme) ? theme.colors.white : theme.colors.black,
  },
  closeIcon: {
    height: theme.spacing(3),
    color: isDark(theme) ? theme.colors.white : theme.palette.primary.main,
  },
}));

export default useStyles;
